import { jsx } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { memo } from "react";
import { toEnumViewClass } from "../../../utils/toEnumViewClass.js";
const EditorTableCellElement = memo(function EditorTableCellElement2({
  attributes,
  children,
  justify,
  headerScope
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...attributes,
      className: useClassName("editorTable-cell", [
        attributes.className,
        toEnumViewClass(justify ? `justify-${justify}` : void 0),
        toEnumViewClass(headerScope ? `headerScope-${headerScope}` : void 0)
      ]),
      children
    }
  );
});
export {
  EditorTableCellElement
};
//# sourceMappingURL=EditorTableCellElement.js.map
